import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiSettings, FiDatabase, FiCloud, FiMonitor, FiCheck, FiX } from 'react-icons/fi';
import SectionTitle from '../components/SectionTitle';
import Card from '../components/Card';

const SettingsSection = ({ title, icon: Icon, children }) => (
  <Card className="mb-6">
    <div className="flex items-center mb-4">
      <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center mr-3">
        <Icon className="h-4 w-4 text-indigo-600" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
    </div>
    {children}
  </Card>
);

const StatusIndicator = ({ status, label }) => (
  <div className="flex items-center justify-between py-2">
    <span className="text-sm text-gray-700">{label}</span>
    <div className={`flex items-center ${status ? 'text-green-600' : 'text-red-600'}`}>
      {status ? <FiCheck className="h-4 w-4 mr-1" /> : <FiX className="h-4 w-4 mr-1" />}
      <span className="text-sm font-medium">{status ? 'Connected' : 'Not Connected'}</span>
    </div>
  </div>
);

function Settings() {
  const [apiStatus] = useState({
    ncb: true,
    dropbox: false,
    github: true,
    cloudflare: true
  });

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <SectionTitle 
        title="Settings & Configuration" 
        subtitle="Monitor your integrations and configure system settings." 
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <SettingsSection title="API Connections" icon={FiDatabase}>
            <div className="space-y-1">
              <StatusIndicator status={apiStatus.ncb} label="NoCodeBackend" />
              <StatusIndicator status={apiStatus.dropbox} label="Dropbox API" />
              <StatusIndicator status={apiStatus.github} label="GitHub" />
              <StatusIndicator status={apiStatus.cloudflare} label="Cloudflare Pages" />
            </div>
          </SettingsSection>

          <SettingsSection title="Environment Variables" icon={FiSettings}>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="font-mono text-gray-600">VITE_NCB_INSTANCE_ID</span>
                <span className="text-green-600 font-medium">Set</span>
              </div>
              <div className="flex justify-between">
                <span className="font-mono text-gray-600">VITE_DROPBOX_APP_KEY</span>
                <span className="text-red-600 font-medium">Missing</span>
              </div>
              <div className="flex justify-between">
                <span className="font-mono text-gray-600">NCB_API_KEY</span>
                <span className="text-green-600 font-medium">Set</span>
              </div>
            </div>
          </SettingsSection>
        </div>

        <div>
          <SettingsSection title="System Information" icon={FiMonitor}>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Environment</span>
                <span className="font-medium">Development</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Build Version</span>
                <span className="font-medium">2.0.0</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Last Updated</span>
                <span className="font-medium">2024-01-15</span>
              </div>
            </div>
          </SettingsSection>

          <SettingsSection title="Quick Actions" icon={FiCloud}>
            <div className="space-y-3">
              <button className="w-full btn-secondary text-left">
                Test API Connections
              </button>
              <button className="w-full btn-secondary text-left">
                Clear Cache & Logs
              </button>
              <button className="w-full btn-secondary text-left">
                Export Configuration
              </button>
            </div>
          </SettingsSection>
        </div>
      </div>
    </motion.div>
  );
}

export default Settings;